import { ListModel } from '../../models/responses/ListModel'
import API from './Api'

class JobApi {
    async GetJobs() {
        return await API.get<ListModel[]>('e/Admin/Jobs')
    }
}

export default new JobApi()